import { InputAdornment, TextField } from '@mui/material';
import React from 'react';

import SearchIcon from '@mui/icons-material/Search';
import CloseIcon from '@mui/icons-material/Close';

//FUNCTION
const SearchBox = ({ disabled = false, search, searchValue, setSearch, placeholder = 'search' }) => {
    const value = searchValue !== undefined ? searchValue : search || '';

    const handleSearch = (event) => {
        try {
            setSearch(event.target.value);
        } catch (e) {
            console.log(e);
        }
    };

    return (
        <>
            <TextField
                disabled={disabled}
                id="outlined-basic"
                size="small"
                fullWidth
                placeholder={placeholder}
                variant="outlined"
                value={value}
                onChange={handleSearch}
                InputProps={{
                    startAdornment: (
                        <InputAdornment position="start">
                            <SearchIcon style={{ fill: 'grey' }} />
                        </InputAdornment>
                    ),
                    endAdornment: value && (
                        <InputAdornment position="end">
                            <CloseIcon style={{ fill: 'grey', cursor: 'pointer' }} onClick={() => setSearch(null)} />
                        </InputAdornment>
                    ),
                }}
            />
        </>
    )
}

export default SearchBox
